// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SubscriptionPrices-module-pricesBox-pYXTe{margin-bottom:10px;align-items:center;display:flex;flex-direction:row;justify-content:space-between}.SubscriptionPrices-module-pricesBox-pYXTe .SubscriptionPrices-module-boldInformation-2tOV9{font-size:14px;letter-spacing:1.5px;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pricesBox": "SubscriptionPrices-module-pricesBox-pYXTe",
	"boldInformation": "SubscriptionPrices-module-boldInformation-2tOV9"
};
export default ___CSS_LOADER_EXPORT___;
